import { render, staticRenderFns } from "./CompleteWarrantyStock.vue?vue&type=template&id=35e08d22&scoped=true&"
import script from "./CompleteWarrantyStock.vue?vue&type=script&lang=js&"
export * from "./CompleteWarrantyStock.vue?vue&type=script&lang=js&"
import style0 from "./CompleteWarrantyStock.vue?vue&type=style&index=0&id=35e08d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e08d22",
  null
  
)

export default component.exports